import styled from "styled-components";

export const PerformerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
